import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { RbidosLeadModel } from 'Pages/lead'
import { ConsentType, RecreateLeadModel, UserModel } from 'Pages/user'

export const userLeadApi = {
	recreateEmail: async (data: RecreateLeadModel) => {
		const res = await axiosDS().post<RbidosLeadModel>(urls.user.lead.recreate, {
			data,
		})
		return res.data
	},

	updateUserLeadType: async (id: string, data: { lead_type: ConsentType }) => {
		const res = await axiosDS().patch<UserModel>(
			urls.user.lead.lead_type.replace(':id', id.toString()),
			{
				data,
			}
		)
		return res.data
	},
}
